import NotificationTypes from '~/constants/types/NotificationTypes';
import {createAction} from 'redux-actions';

export const confirm = createAction(NotificationTypes.CONFIRM);
export const dismiss = createAction(NotificationTypes.DISMISS);
export const error = createAction(NotificationTypes.ERROR);
export const success = createAction(NotificationTypes.SUCCESS);
export const prompt = createAction(NotificationTypes.PROMPT);
